import { Type } from '@angular/core';

import { ChatTemplate } from 'src/app/cyn/chat-module/core/chat.template';
import { ChatTemplateConfig } from 'src/app/cyn/chat-module/types/chat-template.types';
import { WsBlockDeclaration } from '../ws/agent-ws.types';

/** Регистрационные метаданные блока для агента. */
export interface AgentBlockMeta {
    description: string;
    schema: Record<string, unknown>;
}

/**
 * Шаблон чата агента.
 * Расширяет базовый `ChatTemplate` поддержкой деклараций блоков для протокола `declare_blocks`.
 * Единая точка регистрации: компонент + агентная метадата задаются вместе.
 */
export class AgentChatTemplate extends ChatTemplate {
    private readonly declarations: WsBlockDeclaration[] = [];

    public constructor(config: ChatTemplateConfig) {
        super(config);
    }

    /**
     * Зарегистрировать Angular-компонент для типа сообщения (не агентный блок).
     */
    public registerMessage(type: string, component: Type<unknown>): void {
        this.register(type, component);
    }

    /**
     * Зарегистрировать блок: Angular-компонент для рендеринга и декларацию для агента.
     * @param name Имя блока — совпадает с `WsBlock.name` из протокола.
     * @param component Angular-компонент для рендеринга блока.
     * @param meta Описание и схема данных для передачи агенту через `declare_blocks`.
     */
    public registerBlock(name: string, component: Type<unknown>, meta: AgentBlockMeta): void {
        this.register(name, component);
        this.declarations.push({ name, ...meta });
    }

    /** Вернуть все задекларированные блоки для отправки агенту. */
    public getBlockDeclarations(): WsBlockDeclaration[] {
        return [...this.declarations];
    }
}
